'use client';
import React, { useEffect, useRef } from 'react';
import * as powerbi from 'powerbi-client';

export default function PowerBIReport({ embedUrl, accessToken, reportId }) {
  const reportContainer = useRef(null);

  useEffect(() => {
    if (!embedUrl || !accessToken || !reportId) return;

    const models = window['powerbi-client'].models;

    const config = {
      type: 'report',
      id: reportId,
      embedUrl: embedUrl,
      accessToken: accessToken,
      tokenType: models.TokenType.Embed,
      settings: {
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: true }
        },
        background: models.BackgroundType.Transparent
      }
    };

    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    // Clean existing embeds
    powerbiService.reset(reportContainer.current);

    // Embed the report
    powerbiService.embed(reportContainer.current, config);

  }, [embedUrl, accessToken, reportId]);

  return <div ref={reportContainer} style={{ height: '100vh', width: '100%' }} />;
}
